module.exports = __webpack_public_path__ + "img/xxljsb.0aa5e6e1.png";